import { API_BASE, messageFromErrorBody } from './authApi';

/**
 * Public vote flow (no JWT). Used from /wa-vote?t=...
 */
export async function fetchWaVoteInfo(token) {
  const res = await fetch(`${API_BASE}/api/public/wa-vote?t=${encodeURIComponent(token)}`, {
    headers: { Accept: 'application/json' },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل بيانات التصويت'));
  return data;
}

export async function submitWaVote(token, choice) {
  const res = await fetch(`${API_BASE}/api/public/wa-vote`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ token, choice }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ التصويت'));
  return data;
}
